import {url} from 'utils/url';

export const SET_CONNECTION = 'SET_CONNECTION';
export const UPDATE_SYSTEM_DATA = 'UPDATE_SYSTEM_DATA';
export const SET_SELECTED_SCREEN = 'SET_SELECTED_SCREEN';
export const SET_HISTORY_DATA = 'SET_HISTORY_DATA';
export const ADD_HISTORY_POINT = 'ADD_HISTORY_POINT';
export const SET_SCREENSHOT = 'SET_SCREENSHOT';

export const setConnection = (isConnected) => ({ type: SET_CONNECTION, payload: isConnected });
export const setSelectedScreenId = (screenId) => ({ type: SET_SELECTED_SCREEN, payload: screenId });
export const setScreenshot = (screenId, image) => ({ type: SET_SCREENSHOT, payload: { screenId, image } });

export const fetchHistory = (screenId) => async (dispatch) => {
  if (!screenId) return;
  try {
    const res = await fetch(`${url}/system/history/${screenId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json', // Required for fetch when sending JSON
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    const data = await res.json();

    console.log('Raw history data:', data);
    dispatch({ type: SET_HISTORY_DATA, payload: data });
    dispatch({ type: UPDATE_SYSTEM_DATA, payload: data });
  } catch (err) {
    console.error("Failed to fetch history:", err);
  }
};

export const handleIncomingSystemData = (data) => (dispatch, getState) => {
  const { system: state } = getState();

  console.log('system data', data);
  
  // 1. Update the master screens dictionary
  dispatch({ type: UPDATE_SYSTEM_DATA, payload: data });

  // 2. Auto-select the first screen if none is currently selected
  const targetScreenId = state.selectedScreenId || data.screenId;
  if (!state.selectedScreenId) {
    dispatch(setSelectedScreenId(targetScreenId));
  }

  // 3. If this data belongs to the currently viewed screen, update the history chart
  if (targetScreenId === data.screenId) {
    dispatch({ type: ADD_HISTORY_POINT, payload: data });
  }
};

// Updated Screenshot Trigger (API-based)
export const requestScreenshot = (screenId) => async (dispatch) => {
  console.log('Requesting screenshot for screenId:', screenId);
  if (screenId) {
    try {
      const res = await fetch(`${url}/socket/screenshot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Required for fetch when sending JSON
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ screenId: screenId }), // Explicitly stringify the body
      });

      // Fetch does not throw an error on 4xx or 5xx status codes natively, so we check res.ok
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json(); // Parse the response body
      console.log('Screenshot requested via API:', data);
    } catch (error) {
      console.error(error);
      // If you are using toastr in your project:
      // toastr.error('Failed to request screenshot', `${error}`);
    }
  }
};

export const handleInDeviceData = (data) => (dispatch, getState) => {
  const { system: state } = getState() || {}; // Safety fallback included
  
  // Update the master screens dictionary (so OS, CPU, Antivirus UI updates)
  dispatch({ type: UPDATE_SYSTEM_DATA, payload: data });

  // Update the chart if the incoming data belongs to the currently viewed screen
  const targetScreenId = state.selectedScreenId || data.screenId;
  if (targetScreenId === data.screenId) {
    // Assuming 'data.ram' exists in your systemInfo payload
    if (data.ram) {
        dispatch({ type: ADD_HISTORY_POINT, payload: data });
    }
  }
};